import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines multiple class names into a single string, merging Tailwind CSS classes properly.
 * This utility function uses clsx for conditional class joining and twMerge to handle Tailwind class conflicts.
 *
 * @param inputs - Class values to be combined (strings, objects, arrays, etc.)
 * @returns A merged string of class names
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
